/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name settings
 * @description
 *
 * # settings
 *
 * The `settings` module provides settings managment - view/change.
 */
angular.module("settings", [])
/**
 * @ngdoc controller
 * @name settingsCtrl
 * @requires $location, $aside, b17Service, userCache, auth, selector
 *
 * @description
 * Settings Controller
 */
  .controller("settingsCtrl", function (
    $location, $aside, b17Service, userCache, auth, selector, exportToCsv) {

    var ctrl = this;

    ctrl.ld = _;

    // init error and info messages
    ctrl.errorMessage = null;
    ctrl.infoMessage = 'On the left settings panel please select the item that you want to change. Or use buttons "+"/"x" near to the items to add/delete.';

    ctrl.location = $location.path();

    ctrl.selectedSection = userCache.get('settingsSelectedSection');

    ctrl.data = {
      settings: [{
        name: "Groups", groups: true, children: [],
      },
      {
        name: "Providers", providers: true, children: [],
      }],
      selector: {},
    };

    ctrl.bundle = {
      expanded: [ctrl.data.settings[0]],
      selected: null,
      toSave: null,
    };

    ctrl.opts = {
        isSelectable: function(node) {
            return !node.groups && !node.providers;
        }
    };

   ctrl.forms = {
      properties: {},
    };

    // -------------
    // GET REST DATA
    // -------------

    // get b17 config
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        ctrl.data.config = config.data.data.results[0];
      } else {
        checkErrorCodeMessage();
      }
    });

    // get groups/products data
    b17Service.getGroups().then(function (items) {
      if (items.data && items.data.data) {
        var groups = [];
        groups = _.sortBy(items.data.data.results, 'id');
        // get products data
        groups.forEach(function (group) {
          ctrl.data.selector[group.name] = [];
          b17Service.getProducts({
            group: group.name
          }).then(function (products) {
            if (products.data && products.data.data) {
              if (products.data.data.success) {
                group.children = _.sortBy(products.data.data.results, 'name');
                var keys = [];
                group.children.forEach( function(product) {
                  product.tags.forEach(function(tag){
                    if (angular.isUndefined(keys[tag])) {
                      keys[tag] = true;
                      ctrl.data.selector[group.name].push(tag);
                    }
                  });
                });
              }
              ctrl.data.settings[0].children.push(group);
              ctrl.data.settings[0].children = _.sortBy(ctrl.data.settings[0].children, 'id');
            } else {
              checkErrorCodeMessage();
            }
          });
        });
      } else {
        checkErrorCodeMessage();
      }
    });

    // get providers data
    b17Service.getProviders().then(function (items) {
      if (items.data && items.data.data) {
        var providers = [];
        providers = _.sortBy(items.data.data.results, 'id');
        providers.forEach(function (provider) {
          provider.provider = true;
          ctrl.data.settings[1].children.push(provider);
        });
      } else {
        checkErrorCodeMessage();
      }
    });

    ctrl.addProvider = function($event, item) {
      $event.preventDefault();
      $event.stopPropagation();

      // reset info/errors messages
      ctrl.dismissInfo();
      ctrl.dismissError();

      ctrl.bundle.toSave = {
        provider: true,
      };
      ctrl.bundle.selected = null;
      ctrl.forms.properties.$setPristine();
    };

    ctrl.deleteProvider = function($event, item) {
      $event.preventDefault();
      $event.stopPropagation();

      // reset info/errors messages
      ctrl.dismissInfo();
      ctrl.dismissError();
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          var provider = new b17Service.providers();
          provider.$delete({
            name: item.name,
            token: auth.getToken(),
          }, function (result) {
            // check and refresh provider data
            if(result.data && result.data.success) {
              ctrl.infoMessage = 'The Provider "' + item.name + '" has been deleted!';
              // remove provider item from the tree
              ctrl.data.settings[1].children.forEach(function (node) {
                if (node.id == item.id) {
                  _.remove(ctrl.data.settings[1].children, {id: item.id});
                }
              });
            } else {
              checkErrorCodeMessage();
            }
          });
        } else {
          ctrl.errorMessage = 'Please login first!';
        }
      });
    };

    ctrl.addProduct = function($event, item) {
      $event.preventDefault();
      $event.stopPropagation();

      // reset info/errors messages
      ctrl.dismissInfo();
      ctrl.dismissError();

      ctrl.bundle.toSave = {
        group: item.name,
        unit: 'year',
        tags: [],
      };
      selector.removeContent("selector");
      selector.setContent("selector", "tags", ctrl.data.selector[item.name], ctrl.bundle.toSave.tags);
      ctrl.bundle.selected = null;
      ctrl.forms.properties.$setPristine();
    };

    ctrl.deleteProduct = function($event, item) {
      $event.preventDefault();
      $event.stopPropagation();

      // reset info/errors messages
      ctrl.dismissInfo();
      ctrl.dismissError();
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          var product = new b17Service.products();
          product.$delete({
            group: item.group,
            name: item.name,
            token: auth.getToken(),
          }, function (result) {
            // check and refresh product data
            if(result.data && result.data.success) {
              ctrl.infoMessage = 'The Product "' + item.name + '" has been deleted!';
              // remove product item from the tree
              ctrl.data.settings[0].children.forEach(function (node) {
                if (node.name == item.group) {
                  _.remove(node.children, {name: item.name});
                }
              });
            } else {
              checkErrorCodeMessage();
            }
          });
        } else {
          ctrl.errorMessage = 'Please login first!';
        }
      });
    };

    ctrl.save = function() {
      console.log(ctrl.bundle);
      if (!isValidForm()) {
        return;
      }
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          if (ctrl.bundle.toSave.group) {
            saveProduct();
          } else {
            if (ctrl.bundle.toSave.provider) {
              saveProvider();
            } else {
              saveGroup();
            }
          }
        }
      });
    };

    // clear error message
    ctrl.dismissError = function() {
      ctrl.errorMessage = null;
    };

    // clear info message
    ctrl.dismissInfo = function() {
      ctrl.infoMessage = null;
    };

    // ---------
    // SELECTORS
    // ---------

    ctrl.selectUnit = function(unit) {
      ctrl.bundle.toSave.unit = unit;
    };

    ctrl.selectProvider = function(provider) {
      ctrl.bundle.toSave.provider = provider.name;
    };

    ctrl.selectItem = function(item) {
      ctrl.bundle.toSave = angular.copy(item);
      if (item.group) {
        selector.removeContent("selector");
        selector.setContent("selector", "tags", ctrl.data.selector[item.group], ctrl.bundle.toSave.tags);
      }
      ctrl.forms.properties.$setPristine();

      // reset info/errors messages
      ctrl.dismissInfo();
      ctrl.dismissError();
    };

    // select setcion of the settings
    ctrl.selectSection = function (section) {
      ctrl.selectedSection = section;
      userCache.put('settingsSelectedSection', section);
    };

    // ------
    // STYLES
    // ------

    ctrl.getNodeStyle = function(node) {
      if (!node.groups && !node.providers) {
        return "darkgray-text";
      }
      return "gray-text";
    };

    // -------------------
    // BREADCRUMB & RESETS
    // -------------------

    ctrl.checkBreadcrumb = function(name) {
      return (angular.isDefined(ctrl.selectedSection) ? 
        ctrl.selectedSection === name : (name === 'all' ? true : false));
    };

    ctrl.showAll = function () {
      ctrl.selectedSection = 'all';
      userCache.put('settingsSelectedSection', 'all');
    };
    
    // ------------------------------
    // GROUPS AND PRODUCTS MANAGEMENT
    // ------------------------------

    // save group data
    function saveGroup() {
      if (ctrl.bundle.toSave.id) {
        b17Service.groups.get({
          name: ctrl.bundle.selected.name,
        }, function(group) {
          if (group.id) {
            if (ctrl.bundle.toSave.name) {
              group.name = ctrl.bundle.toSave.name;
              if (ctrl.bundle.toSave.description) {
                group.description = ctrl.bundle.toSave.description;
              }
              if (ctrl.bundle.toSave.article) {
                group.article = ctrl.bundle.toSave.article;
              }
              group.$save({
                name: ctrl.bundle.selected.name,
                token: auth.getToken(),
              }, function (groupItem) {
                // check the data was saved correctly
                if(groupItem.id) {
                  ctrl.infoMessage = 'The Group "' + groupItem.name + '" has been saved!';
                  ctrl.bundle.selected.name = groupItem.name;
                  ctrl.bundle.selected.description = groupItem.description;
                  ctrl.bundle.selected.article = groupItem.article;
                } else {
                  checkErrorCodeMessage();
                }
              });
            } else {
              ctrl.errorMessage = 'A group name is required!';        
            }
          } else {
            checkErrorCodeMessage();
          }
        });
      } else {
          ctrl.errorMessage = 'Functionality to adding a new group is disabled!';        
      }
    }

    // save provider data
    function saveProvider() {
      var providerName = ctrl.bundle.toSave.name;
      if (ctrl.bundle.selected && ctrl.bundle.selected.name) {
        providerName = ctrl.bundle.selected.name;
      }
      b17Service.providers.get({
        name: providerName,
      }, function(provider) {
        if (provider.id) {
          if (ctrl.bundle.toSave.name) {
            provider.name = ctrl.bundle.toSave.name;
            if (ctrl.bundle.toSave.article) {
              provider.article = ctrl.bundle.toSave.article;
            }
            if (ctrl.bundle.toSave.description) {
              provider.description = ctrl.bundle.toSave.description;
            }
            provider.$save({
              name: providerName,
              token: auth.getToken(),
            }, function (providerItem) {
              // check the data was saved correctly
              if(providerItem.id) {
                ctrl.infoMessage = 'The Provider "' + providerItem.name + '" has been saved!';
                ctrl.bundle.selected.name = providerItem.name;
                ctrl.bundle.selected.article = providerItem.article;
                ctrl.bundle.selected.description = providerItem.description;
              } else {
                checkErrorCodeMessage();
              }
            });
          } else {
            ctrl.errorMessage = 'A provider name is required!';        
          }
        } else {
          // if a provider does not exist, create new
          if (provider.data && provider.data.error == 404) {
            createProvider();
          } else {
            checkErrorCodeMessage();
          }
        }
      });
    }

    // save product data
    function saveProduct() {
      var group = ctrl.bundle.toSave.group;
      var name = ctrl.bundle.toSave.name;
      if (ctrl.bundle.toSave.id) {
        group = ctrl.bundle.selected.group;
        name = ctrl.bundle.selected.name;
      }
      b17Service.products.get({
        group: group,
        name: name,
      }, function(product) {
          // if the product exists
          if (product.id) {
            var productCopy = angular.copy(product);
            product.name = ctrl.bundle.toSave.name;
            if (ctrl.bundle.toSave.article) {
              product.article = ctrl.bundle.toSave.article;
            }
            if (ctrl.bundle.toSave.description) {
              product.description = ctrl.bundle.toSave.description;
            }
            if (ctrl.bundle.toSave.tags) {
              product.tags = ctrl.bundle.toSave.tags;
            }
            if (ctrl.bundle.toSave.unit) {
              product.unit = ctrl.bundle.toSave.unit;
            }
            if (ctrl.bundle.toSave.provider) {
              product.provider = ctrl.bundle.toSave.provider;
            }
            product.$save({
              name: name,
              token: auth.getToken(),
            }, function (productItem) {
              // check and refresh product data
              if(productItem.id) {
                refreshProduct(productItem);
              } else {
                checkErrorCodeMessage();
              }
            });
          } else {
            // if a product does not exist, create new
            if (product.data && product.data.error == 404) {
              createProduct();
            } else {
              checkErrorCodeMessage();
            }
          }
      });
    }

    // refresh node with product
    function refreshProduct(product) {
      ctrl.infoMessage = 'The Product "' + product.name + '" has been saved!';
      if (ctrl.bundle.toSave.id) {
        ctrl.bundle.selected.name = product.name;
        ctrl.bundle.selected.article = product.article;
        ctrl.bundle.selected.description = product.description;
        ctrl.bundle.selected.tags = product.tags;
        ctrl.bundle.selected.unit = product.unit;
        ctrl.bundle.selected.provider = product.provider;
      } else {
        ctrl.data.settings[0].children.forEach(function (item) {
          if (item.name == product.group) {
            ctrl.bundle.expanded.push(item);
            item.children.forEach(function (element) {
              if (element.id == product.id) {
                element.name = product.name;
                element.article = product.article;
                element.description = product.description;
                element.tags = product.tags;
                element.unit = product.unit;
                element.provider = product.provider;
              }
            });
            item.children = _.sortBy(item.children, 'name');
          }
        });
        ctrl.bundle.selected = product;
      }
    }

    // add new provider and refresh node
    function createProvider() {
      var provider = new b17Service.providers();
      provider.name = ctrl.bundle.toSave.name;
      if (ctrl.bundle.toSave.article) {
        provider.article = ctrl.bundle.toSave.article;
      }
      if (ctrl.bundle.toSave.description) {
        provider.description = ctrl.bundle.toSave.description;
      }
      provider.$add({
        token: auth.getToken(),
      }, function (providerItem) {
        // check and refresh product data
        if(providerItem.id) {
          ctrl.infoMessage = 'The Provider "' + providerItem.name + '" has been saved!';
          ctrl.bundle.expanded.push(ctrl.data.settings[1]);
          ctrl.data.settings[1].children.push(providerItem);
          ctrl.data.settings[1].children = _.sortBy(ctrl.data.settings[1].children, 'id');
          ctrl.bundle.selected = providerItem;
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    // add new product and refresh node
    function createProduct() {
      var product = new b17Service.products();
      product.group = ctrl.bundle.toSave.group;
      product.name = ctrl.bundle.toSave.name;
      if (ctrl.bundle.toSave.article) {
        product.article = ctrl.bundle.toSave.article;
      }
      if (ctrl.bundle.toSave.description) {
        product.description = ctrl.bundle.toSave.description;
      }
      if (ctrl.bundle.toSave.tags) {
        product.tags = ctrl.bundle.toSave.tags;
      }
      if (ctrl.bundle.toSave.unit) {
        product.unit = ctrl.bundle.toSave.unit;
      }
      if (ctrl.bundle.toSave.provider) {
        product.provider = ctrl.bundle.toSave.provider;
      }
      product.$add({
        token: auth.getToken(),
      }, function (productItem) {
        // check and refresh product data
        if(productItem.id) {
          ctrl.infoMessage = 'The Product "' + productItem.name + '" has been saved!';
          ctrl.data.settings[0].children.forEach(function (item) {
            if (item.name == productItem.group) {
              if (!item.children) {
                item.children = [];
              }
              ctrl.bundle.expanded.push(item);
              item.children.push(productItem);
              item.children = _.sortBy(item.children, 'name');
            }
          });
          ctrl.bundle.selected = productItem;
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    // check login
    function checkLogin() {
      return auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          return true;
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
          return false;
        }
      });   
    }

    // check if form has valid values
    function isValidForm() {
      ctrl.errorMessage = null;
      if (ctrl.forms.properties.$invalid) {
        if (ctrl.forms.properties.$error.required) {
          ctrl.errorMessage = 'Please complete all required fields.';
        } else {
          ctrl.errorMessage = 'Please complete all fields correctly.';
        }
        return false;
      }

      return true;
    }

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        ctrl.errorMessage = 'Error: (' + userCache.get('lastErrorCode') + ') ' + userCache.get('lastErrorMessage');
      } else {
        ctrl.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

    // ----------------------------------
    // EXPORT TO CSV, created by Eugene Semennikov
    // ----------------------------------

    ctrl.exportAllProductRecordsToCsv = exportToCsv.downloadAllProductRecordsToFile;

  });

})();
